<template>
  <div class="" style="height: 600px;">
    <div :class="`box ${d.close?'closex':''}`" :style="d.style" @click="close">
      <div class="item"></div>
      <div class="item"></div>
      <div class="item"></div>
    </div>
<!--    <div :class="`box`"  @click="">-->
<!--      <div class="item"></div>-->
<!--      <div class="item"></div>-->
<!--      <div class="item"></div>-->
<!--    </div>-->
  </div>

</template>

<script setup>

import {reactive} from "vue";

let d = reactive({
  close:false,
  style:{}
})

function close(){
  d.style.height = "200px"
  setTimeout(()=>{
    d.close = !d.close
  },100)

}

</script>

<style scoped>
.box{
  width: 50px;
  /*max-height: 300px;*/
  border: 1px solid red;
  transition: all 1s;
  /*overflow: hidden;*/
}
.box.closex{
  /*max-height: 10px;*/
  height: 0 !important;
}
.item{
  width: 50px;
  height: 20px;
  border: 1px solid green;
}
</style>